<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card>
        <v-form ref="update_form" @submit.prevent="update_employee">
          <div class="pa-3">
            <div>
              <div>
                <div class="d-flex">
                  <v-icon>mdi-account</v-icon>
                  <div class="ml-1">รหัสพนักงาน : {{ add_customer.id }}</div>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 ml-1">
                  <v-tooltip right color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" label="ชื่อสำหรับเข้าสู่ระบบ" @keypress="isCharacter($event)" prepend-inner-icon="mdi-account-outline" :rules="loginRules" hide-details="auto" required v-model="add_customer.username" outlined>
                        <v-icon color="black lighten-1" slot="append" v-bind="attrs" v-on="on">
                          mdi-alert-circle
                        </v-icon>
                      </v-text-field>
                    </template>
                    <span>กรุณากรอกตัวอักษร A-z ก-ฮ 0-9</span>
                  </v-tooltip>
                </div>
                <div class="mt-3 ml-1">
                  <v-text-field color="#86bc3a" label="ชื่อ - สกุล" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อ - สกุล']" hide-details="auto" v-model="add_customer.name" required outlined></v-text-field>
                </div>
                <div class="mt-3 ml-1">
                  <v-text-field color="#86bc3a" label="เบอร์โทรศัพท์" type="tel" maxlength="11" prepend-inner-icon="mdi-phone-outline" @keypress="isNumber($event, add_customer.telephone)" hide-details="auto"  v-model="add_customer.telephone" outlined></v-text-field>
                </div>
                <div class="mt-3 ml-1">
                  <v-text-field color="#86bc3a" label="อีเมล" type="email" @keypress="isEmail($event)" prepend-inner-icon="mdi-email-outline" hide-details="auto"  v-model="add_customer.email" outlined></v-text-field>
                </div>
              </div>
              <div class="mt-3">
                <h3>สิทธิ์การเข้าถึงข้อมูลของพนักงาน</h3>
              </div>
              <div class="grid_threeseven">
                <h4 class="media_none">ระบบ</h4>
                <h4 class="media_none">สิทธิ์การเข้าใช้งาน</h4>
                <div>จัดการสมาชิก ลูกค้า</div>
                <div class="grid_threeseven_detail">
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="customer_ck.manage_customer_create" hide-details="auto"></v-checkbox>
                    <div>
                      เพิ่มสมาชิก
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="customer_ck.manage_customer_list" hide-details="auto"></v-checkbox>
                    <div>
                      ดูรายละเอียดสมาชิก
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="customer_ck.manage_customer_edit" hide-details="auto"></v-checkbox>
                    <div>
                      แก้ไขสมาชิก
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="customer_ck.manage_customer_delete" hide-details="auto"></v-checkbox>
                    <div>
                      ลบสมาชิก
                    </div>
                  </div>
                </div>
                <div>จัดการพาร์ทเนอร์</div>
                <div class="grid_threeseven_detail">
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="partner_ck.manage_partner_create" hide-details="auto"></v-checkbox>
                    <div>
                      เพิ่มสมาชิก
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="partner_ck.manage_partner_list" hide-details="auto"></v-checkbox>
                    <div>
                      ดูรายละเอียดสมาชิก
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="partner_ck.manage_partner_edit" hide-details="auto"></v-checkbox>
                    <div>
                      แก้ไขสมาชิก
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="partner_ck.manage_partner_delete" hide-details="auto"></v-checkbox>
                    <div>
                      ลบสมาชิก
                    </div>
                  </div>
                </div>
                <div>จัดการสินค้า</div>
                <div class="grid_threeseven_detail">
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="product_ck.manage_product_list" hide-details="auto"></v-checkbox>
                    <div>
                      ดูรายการสินค้า
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="product_ck.manage_product_create" hide-details="auto"></v-checkbox>
                    <div>
                      เพิ่มสินค้า
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="product_ck.manage_product_edit" hide-details="auto"></v-checkbox>
                    <div>
                      แก้ไขสินค้าทั้งหมด
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="product_ck.manage_product_delete" hide-details="auto"></v-checkbox>
                    <div>
                      ลบสินค้า
                    </div>
                  </div>
                </div>
                <div>จัดการประเภทสินค้า</div>
                <div class="grid_threeseven_detail">
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="product_type_ck.manage_type_product_list" hide-details="auto"></v-checkbox>
                    <div>
                      เมนูประเภทสินค้า
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="product_type_ck.manage_type_product_create" hide-details="auto"></v-checkbox>
                    <div>
                      เพิ่มประเภทสินค้า
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="product_type_ck.manage_type_product_edit" hide-details="auto"></v-checkbox>
                    <div>
                      แก้ไขประเภทสินค้า
                    </div>
                  </div>

                </div>
                <div>จัดการหน่วยนับ</div>
                <div class="grid_threeseven_detail">
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="unit_ck.manage_units_list" hide-details="auto"></v-checkbox>
                    <div>
                      เมนูหน่วยนับ
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="unit_ck.manage_units_create" hide-details="auto"></v-checkbox>
                    <div>
                      เพิ่มหน่วยนับ
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="unit_ck.manage_units_edit" hide-details="auto"></v-checkbox>
                    <div>
                      แก้ไขหน่วยนับ
                    </div>
                  </div>
                </div>

                <div>จัดการนับสต๊อกคลังหลัก</div>
                <div class="grid_threeseven_detail">
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="stock_warehouse_ck.count_warehouse" hide-details="auto"></v-checkbox>
                    <div>
                      ประวัติการนับ
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="stock_warehouse_ck.count_warehouse_create" hide-details="auto"></v-checkbox>
                    <div>
                      สร้างรอบนับ
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="stock_warehouse_ck.count_warehouse_count" hide-details="auto"></v-checkbox>
                    <div>
                      นับสต๊อก
                    </div>
                  </div>
                </div>

                <div>จัดการนับสต๊อกคลังสาขาย่อย</div>
                <div class="grid_threeseven_detail">
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="stock_ck.manage_stock" hide-details="auto"></v-checkbox>
                    <div>
                      ประวัติการนับ
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="stock_ck.manage_stock_create" hide-details="auto"></v-checkbox>
                    <div>
                      สร้างรอบนับ
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="stock_ck.manage_stock_count" hide-details="auto"></v-checkbox>
                    <div>
                      นับสต๊อก
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-checkbox class="ma-0" color="#8cc63e"  v-model="stock_ck.manage_stock_barcode" hide-details="auto"></v-checkbox>
                    <div>
                      อัพโหลดไฟล์บาร์โค้ด
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <v-btn large type="submit" class="white--text grad-success-bg btn_mobile" style="font-size: 18px">บันทึกข้อมูล</v-btn>
              </div>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/axios.js';
import Swal from 'sweetalert2';
import {isTelephone, onPaste, validateCharacter, validateEmail} from "@/js/handler";
export default {
  name: "EditEmployee",
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: false,
      type_user: "1",
      address_delivery: "1",
      emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'อีเมลไม่ถูกต้อง !'],
      phoneRules: [v => ( v.length === 10 ) || "เบอร์โทรศัพท์ไม่ถูกต้อง !",],
      loginRules: [
        v => !!v || 'กรุณากรอกชื่อสำหรับเข้าสู่ระบบ',
        v => ( v.length > 2 ) || 'กรุณากรอกตัวอักษรมากกว่า 3 ตัวขึ้นไป',
      ],
      add_customer: {
        id: null,
        username: '',
        name: null,
        telephone: '',
        email: null,
      },
      customer_ck: {
        manage_customer_list: 1,
        manage_customer_create: 1,
        manage_customer_edit: 1,
        manage_customer_delete: 1
      },
      partner_ck: {
        manage_partner_list: 1,
        manage_partner_create: 1,
        manage_partner_edit: 1,
        manage_partner_delete: 1
      },
      product_ck: {
        manage_product_list: 1,
        manage_product_create: 1,
        manage_product_edit: 1,
        manage_product_delete: 1,
      },
      product_type_ck: {
        manage_type_product_list: 1,
        manage_type_product_create: 1,
        manage_type_product_edit: 1,
        manage_type_product_delete: 1
      },
      unit_ck: {
        manage_units_list: 1,
        manage_units_create: 1,
        manage_units_edit: 1,
        manage_units_delete: 1
      },
      stock_warehouse_ck: {
        count_warehouse: 1,
        count_warehouse_create: 1,
        count_warehouse_count: 1,
      },
      stock_ck: {
        manage_stock: 1,
        manage_stock_create: 1,
        manage_stock_count: 1,
        manage_stock_barcode: 1,
      }
    }
  },
  methods: {
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    isCharacter: function (evt) {
      return validateCharacter(evt)
    },
    alertUpdate() {
      Swal.fire({
        title: 'บันทึกข้อมูลเรียบร้อย !',
        icon: 'success',
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then(() => {
        this.$router.push('/admin')
      })
    },
    getEdit_Data() {
      this.loading_page = true
      HTTP.post('/users/show', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true){
          this.loading_page = false
          this.add_customer.id = res.data.object.user_code;
          this.add_customer.username = res.data.object.username;
          this.add_customer.name = res.data.object.name;
          this.add_customer.telephone = res.data.object.telephone;
          this.add_customer.email = res.data.object.email;
          this.customer_ck.manage_customer_list = res.data.object.manage_customer_list;
          this.customer_ck.manage_customer_create = res.data.object.manage_customer_create;
          this.customer_ck.manage_customer_edit = res.data.object.manage_customer_edit;
          this.customer_ck.manage_customer_delete = res.data.object.manage_customer_delete;
          this.partner_ck.manage_partner_list = res.data.object.manage_partner_list;
          this.partner_ck.manage_partner_create = res.data.object.manage_partner_create;
          this.partner_ck.manage_partner_edit = res.data.object.manage_partner_edit;
          this.partner_ck.manage_partner_delete = res.data.object.manage_partner_delete;
          this.product_ck.manage_product_list = res.data.object.manage_product_list;
          this.product_ck.manage_product_create = res.data.object.manage_product_create;
          this.product_ck.manage_product_edit = res.data.object.manage_product_edit;
          this.product_ck.manage_product_delete = res.data.object.manage_product_delete;
          this.product_type_ck.manage_type_product_list = res.data.object.manage_type_product_list;
          this.product_type_ck.manage_type_product_create = res.data.object.manage_type_product_create;
          this.product_type_ck.manage_type_product_edit = res.data.object.manage_type_product_edit;
          this.product_type_ck.manage_type_product_delete = res.data.object.manage_type_product_delete;
          this.unit_ck.manage_units_list = res.data.object.manage_units_list;
          this.unit_ck.manage_units_create = res.data.object.manage_units_create;
          this.unit_ck.manage_units_edit = res.data.object.manage_units_edit;
          this.unit_ck.manage_units_delete = res.data.object.manage_units_delete;
          this.stock_ck.manage_stock = res.data.object.manage_stock;
          this.stock_ck.manage_stock_create = res.data.object.manage_stock_create;
          this.stock_ck.manage_stock_count = res.data.object.manage_stock_count;
          this.stock_ck.manage_stock_barcode = res.data.object.manage_stock_barcode;
          this.stock_warehouse_ck.count_warehouse = res.data.object.count_warehouse
          this.stock_warehouse_ck.count_warehouse_create = res.data.object.count_warehouse_create
          this.stock_warehouse_ck.count_warehouse_count = res.data.object.count_warehouse_count
        }
      })
    },
    update_employee() {
      if (this.add_customer.username !== null && this.add_customer.name !== null && this.add_customer.username !== '' && this.add_customer.name !== '') {
        HTTP.post('/users/employee/edit', {
          id: this.$route.params.id,
          emp_code: this.add_customer.id,
          username: this.add_customer.username,
          name: this.add_customer.name,
          telephone: this.add_customer.telephone,
          email: this.add_customer.email,
          manage_customer_list: this.customer_ck.manage_customer_list,
          manage_customer_create: this.customer_ck.manage_customer_create,
          manage_customer_edit: this.customer_ck.manage_customer_edit,
          manage_customer_delete: this.customer_ck.manage_customer_delete,
          manage_partner_list: this.partner_ck.manage_partner_list,
          manage_partner_create: this.partner_ck.manage_partner_create,
          manage_partner_edit: this.partner_ck.manage_partner_edit,
          manage_partner_delete: this.partner_ck.manage_partner_delete,
          manage_product_list: this.product_ck.manage_product_list,
          manage_product_create: this.product_ck.manage_product_create,
          manage_product_edit: this.product_ck.manage_product_edit,
          manage_product_delete: this.product_ck.manage_product_delete,
          manage_type_product_list: this.product_type_ck.manage_type_product_list,
          manage_type_product_create: this.product_type_ck.manage_type_product_create,
          manage_type_product_edit: this.product_type_ck.manage_type_product_edit,
          manage_type_product_delete: this.product_type_ck.manage_type_product_delete,
          manage_units_list: this.unit_ck.manage_units_list,
          manage_units_create: this.unit_ck.manage_units_create,
          manage_units_edit: this.unit_ck.manage_units_edit,
          manage_units_delete: this.unit_ck.manage_units_delete,
          manage_stock: this.stock_ck.manage_stock,
          manage_stock_create: this.stock_ck.manage_stock_create,
          manage_stock_count: this.stock_ck.manage_stock_count,
          manage_stock_barcode: this.stock_ck.manage_stock_barcode,
          count_warehouse: this.stock_warehouse_ck.count_warehouse,
          count_warehouse_create: this.stock_warehouse_ck.count_warehouse_create,
          count_warehouse_count: this.stock_warehouse_ck.count_warehouse_count,
        }).then((res) => {
          if (res.data.success === true){
            this.alertUpdate();
          }
          else {
            Swal.fire({
              title: 'ไม่สามารถบันทึกได้ !',
              text: res.data.object,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.add_customer.username = ''
            })
          }
        });
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถบันทึกได้ !',
          text: 'กรุณาตรวจสอบข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.$refs.update_form.validate()
        })
      }
    },
  },
  mounted() {
    this.getEdit_Data();
  }
}
</script>

<style scoped>
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_threeseven {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-gap: 15px 0;
}

.grid_threeseven_detail {
  display: grid;
  grid-template-columns: 25% 30% 25% 20%;
}

@media only screen and (max-width: 1000px) {
  .media_none {
    display: none;
  }

  .grid_threeseven {
    grid-template-columns: 100%;
  }

  .grid_threeseven_detail {
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 500px){
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .btn_mobile {
    width: 100%;
  }
}
</style>
